import React from 'react';
import { Badge, Button, Modal, Spinner, Table } from 'react-bootstrap';
import { IoCloseOutline, IoRefreshOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../utilities/common';
import { formatUserName } from '../../reports/reportHelper';

const AuditHistoryModal = ({ show, onClose, onRestoreVersion, reportName, reportStatus, auditHistory }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onClose} size="xl" centered dialogClassName="narrative-large-modal">
      <Modal.Header>
        <div>
          <Modal.Title>{t('Audit History')}</Modal.Title>
          <div className="text-muted">{t('View all version history and restore previous versions')}</div>
        </div>
        <Button variant="link" onClick={onClose}><IoCloseOutline size={24} /></Button>
      </Modal.Header>
      <Modal.Body>
        {!auditHistory ? (
          <div className="text-center p-4"><Spinner animation="border" size="sm" /></div>
        ) : (
          <Table responsive hover>
            <thead>
              <tr>
                <th>{t('Report Version')}</th>
                <th>{t('Report Name')}</th>
                <th>{t('Last Update Date')}</th>
                <th>{t('Last Updated User')}</th>
                <th style={{ maxWidth: '300px' }}>{t('Updated Sections')}</th>
                <th className="text-right">{t('Actions')}</th>
              </tr>
            </thead>
            <tbody>
              {auditHistory.map((version, index) => (
                <tr key={version.version} className={index === 0 ? 'narrative-current-version' : ''}>
                  <td>
                    <strong>{version.version}</strong>
                    {index === 0 && <Badge variant="success" className="ml-2">{t('Current')}</Badge>}
                  </td>
                  <td>{reportName}</td>
                  <td>{formatDate(version.updatedAt)}</td>
                  <td>{formatUserName(version.updatedBy)}</td>
                  <td style={{ maxWidth: '300px' }}>
                    {version.updatedSections.map((section) => (
                      <Badge key={section} variant="light" className="mr-1 narrative-section-pill">{section}</Badge>
                    ))}
                  </td>
                  <td className="text-right">
                    {index !== 0 && reportStatus !== 'completed' && (
                      <Button variant="outline-secondary" size="sm" onClick={() => onRestoreVersion(version.version)}>
                        <IoRefreshOutline className="mr-1" />
                        {t('Restore Version')}
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onClose}>{t('Close')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AuditHistoryModal;
